type Place = { id: string } & Record<string, any>;

export const getVisitedPlaces = (visitedIds: string[] = [], places: Place[] = []) => {
  const placesById = new Map(places.map((place) => [place.id, place]));

  return [...visitedIds]
    .reverse()
    .map((id) => placesById.get(id))
    .filter((place): place is Place => Boolean(place));
};
